import { DeliveryOptionCode } from 'src/types';
import { getDateDifferenceInDays } from 'src/utils/date';

const getExpressDeliveryCopy = (date: string | null) => {
  switch (getDateDifferenceInDays(new Date(), new Date(date!))) {
    case 1:
      return 'Tracked Next Day Delivery';
    case 2:
      return 'Tracked Two Day Delivery';
    default:
      return 'Tracked Express Delivery';
  }
};

export const getDeliveryOptionName = (code: DeliveryOptionCode, date: string | null) => {
  switch (code) {
    case 'FREE':
      return 'Free Delivery';
    case 'SATURDAY':
      return 'Saturday Delivery';
    case 'EXPRESS_24':
      return getExpressDeliveryCopy(date);
    default:
      return 'Standard Delivery';
  }
};
